import * as React from 'react'

// HOC
import withContext from '@hoc/withContext/withContext'
import withProvider from '@hoc/withProvider/withProvider'

const Wrapper = (props: Wrapper.IProps) => {
  const { config, data } = props
  const { view, content, ...other } = config
  const Component: React.FunctionComponent<{ config: object; content: object; data: object }> = view

  return <Component config={other} content={content} data={data} />
}

export default withProvider(withContext(Wrapper))
